// src/services/dashboardService.js
import api from './api';

export const dashboardService = {
  /**
   * Obține statisticile pentru dashboard
   * @returns {Promise<Object>} Statistici dashboard
   */
  async getStatistics() {
    try {
      console.log('Fetching dashboard statistics...');
      const response = await api.get('/dashboard/statistics');
      
      console.log('Dashboard statistics received:', {
        totalClients: response.data?.TotalClients,
        totalContracts: response.data?.TotalContracts,
        activeContracts: response.data?.ActiveContracts,
        timestamp: new Date().toISOString()
      });

      // Validare date primite
      if (!response.data) {
        throw new Error('No data received from statistics endpoint');
      }

      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard statistics:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      });
      throw error;
    }
  },

  /**
   * Obține activitatea recentă
   * @returns {Promise<Array>} Lista activităților recente
   */
  async getRecentActivity() {
    try {
      console.log('Fetching recent activity...');
      const response = await api.get('/dashboard/recent-activity');
      
      console.log('Recent activity received:', {
        count: response.data?.length || 0,
        timestamp: new Date().toISOString()
      });

      // Validare date primite
      if (!Array.isArray(response.data)) {
        console.warn('Recent activity is not an array, returning empty array');
        return [];
      }

      return response.data;
    } catch (error) {
      console.error('Error fetching recent activity:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      });
      throw error;
    }
  },

  /**
   * Obține alertele și notificările
   * @returns {Promise<Array>} Lista alertelor
   */
  async getAlerts() {
    try {
      console.log('Fetching alerts...');
      const response = await api.get('/dashboard/alerts');
      
      console.log('Alerts received:', {
        count: response.data?.length || 0,
        highPriority: response.data?.filter(a => a.Priority === 'High').length || 0,
        timestamp: new Date().toISOString()
      });

      // Validare date primite
      if (!Array.isArray(response.data)) {
        console.warn('Alerts is not an array, returning empty array');
        return [];
      }

      return response.data;
    } catch (error) {
      console.error('Error fetching alerts:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      });
      throw error;
    }
  },

  /**
   * Test conexiune la API
   * @returns {Promise<Object>} Status conexiune
   */
  async testConnection() {
    try {
      console.log('Testing API connection...');
      
      // Încercăm să obținem statisticile
      const statsResponse = await api.get('/dashboard/statistics');
      
      console.log('API connection test successful');
      
      return {
        success: true,
        message: 'Conexiune la API reușită',
        data: statsResponse.data
      };
    } catch (error) {
      console.error('API connection test failed:', error);
      
      return {
        success: false,
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText
      };
    }
  }
};

export default dashboardService;